export const assinaturaContratoEnum = {
  Eletronica: 'Eletronica',
  Impressa: 'Impressa',
} as const
export type TAssinaturaContratoEnum = (typeof assinaturaContratoEnum)[keyof typeof assinaturaContratoEnum]

export const formaPagamentoComissaoEnum = {
  PagaPelaPlaenge: 'PagaPelaPlaenge',
  PagaPeloCliente: 'PagaPeloCliente',
} as const
export type TFormaPagamentoComissaoEnum = (typeof formaPagamentoComissaoEnum)[keyof typeof formaPagamentoComissaoEnum]

export const ClienteRegimeCasamentoEnum = {
  SeparacaoTotalBens: 'SeparacaoTotalBens',
  ComunhaoParcialBens: 'ComunhaoParcialBens',
  ComunhaoUniversalBens: 'ComunhaoUniversalBens',
  SeparacaoLegal: 'SeparacaoLegal',
} as const
export type TClienteRegimeCasamentoEnum = (typeof ClienteRegimeCasamentoEnum)[keyof typeof ClienteRegimeCasamentoEnum]

export const tipoAssinaturaEnum = {
  Simples: 'Simples',
  Dupla: 'Dupla',
} as const
export type TTipoAssinaturaEnum = (typeof tipoAssinaturaEnum)[keyof typeof tipoAssinaturaEnum]

export const tipoDoCompradorEnum = {
  PessoaFisica: 'PessoaFisica',
  PessoaJuridica: 'PessoaJuridica',
} as const
export type TTipoDoCompradorEnum = (typeof tipoDoCompradorEnum)[keyof typeof tipoDoCompradorEnum]

export const tipoDoVinculoDoCompradorEnum = {
  MaePai: 'MaePai',
  Conjuge: 'Conjuge',
  Procurador: 'Procurador',
  Representante: 'Representante',
} as const
export type TTipoDoVinculoDoCompradorEnum =
  (typeof tipoDoVinculoDoCompradorEnum)[keyof typeof tipoDoVinculoDoCompradorEnum]

export const tipoDeDocumentoEnum = {
  CNH: 'CNH',
  RG: 'RG',
  CPF: 'CPF',
  CertidaoDeNascimento: 'CertidaoDeNascimento',
  CertidaoDeCasamento: 'CertidaoDeCasamento',
  ComprovanteDeResidencia: 'ComprovanteDeResidencia',
  Procuracao: 'Procuracao',
  CartaoCNPJ: 'CartaoCNPJ',
  ContratoSocial: 'ContratoSocial',
  UltimaAlteracao: 'UltimaAlteracao',
  CertidaoJuntaComercial: 'CertidaoJuntaComercial',
  ComprovanteDeEnderecoDaEmpresa: 'ComprovanteDeEnderecoDaEmpresa',
  OutroDocumento: 'OutroDocumento',
  ComprovanteDePagamento: 'ComprovanteDePagamento',
  Checklist: 'Checklist',
} as const
export type TTipoDeDocumentoEnum = (typeof tipoDeDocumentoEnum)[keyof typeof tipoDeDocumentoEnum]

export const opcaoVagaEnum = {
  Pendente: 'Pendente',
  Padrao: 'Padrao',
  Customizada: 'Customizada',
} as const
export type TOpcaoVagaEnum = (typeof opcaoVagaEnum)[keyof typeof opcaoVagaEnum]

export const tipoEmolumentoEnum = {
  AlienacaoFiduciaria: 'AlienacaoFiduciaria',
  ContratoCompraVenda: 'ContratoCompraVenda',
} as const
export type TTipoEmolumentoEnum = (typeof tipoEmolumentoEnum)[keyof typeof tipoEmolumentoEnum]
